import { Navigate, Route, Routes } from 'react-router-dom'
import Area from '../pages/area'
import { FormDepartment } from '../pages/departments/pages/form'
import Department from '../pages/departments/pages/main'
import { DepartmentContextProvider } from '../pages/departments/context'
import GeneralConfigRoutes from '../pages/generalConfig/routes'

const OrganizationChart = () => {
  return (
    <DepartmentContextProvider>
      <Routes>
        <Route index element={<Navigate to="area" />} />
        <Route path="area" element={<Area />} />
        <Route path="departments" element={<Department />} />
        <Route path="departments/create" element={<FormDepartment />} />
        <Route path="departments/edit/:id" element={<FormDepartment />} />
        <Route path="organization-area-department/*" element={<GeneralConfigRoutes />} />
      </Routes>
    </DepartmentContextProvider>
  )
}

export default OrganizationChart
